import { RawRootScope, schemaScope } from "../scope.js";
// the import ordering here is important so builtin keywords can be resolved
// and used to bootstrap nodes with constraints
import { tsKeywords } from "./tsKeywords.js";
import { jsObjects } from "./jsObjects.js";
import { parsing } from "./parsing.js";
import { validation } from "./validation.js";
export const ambientRootScope = schemaScope({
    ...tsKeywords,
    ...jsObjects,
    ...validation,
    parse: parsing
    // TODO: remove cast
});
RawRootScope.ambient = ambientRootScope.raw;
export const keywordNodes = ambientRootScope.export();
